/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query TrustcenterQuery($uid: String!) {
    prismic {
      trustcenter(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_TrustcenterBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_TrustcenterBodyListgridv2 {
          type
            label
            primary {
              background_color
              background_image
              heading
              heading_color
              list_column_number
              list_item_alignment_position
              list_item_heading_color
              list_item_text_color
              list_item_icon_position
              list_item_icon_size
              subheading
              subheading_color
              text_color
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              annotation
            }
            fields {
              list_item_heading
              list_item_icon
              list_item_text
              list_item_url_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_item_url_text
            }
        },
        ... on PRISMIC_TrustcenterBodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        },
        ... on PRISMIC_TrustcenterBodyQuote {
          type
            label
            primary {
              quote
              align_content
              author_details
              author_image
              author_name
              background_color
              background_image
              logo
              text_color
            }
        },
        ... on PRISMIC_TrustcenterBodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        },
        ... on PRISMIC_TrustcenterBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        },
        ... on PRISMIC_TrustcenterBodyDocumentcontent {
          type
            label
            fields {
              breadcrumb_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              breadcrumb_active
              breadcrumb_text
            }
            primary {
              text_color
              background_color
              background_image
              heading
              heading_color
              subheading
              subheading_color
              document_content_text
              modal_link_title
              modal_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              modal_ref_title
              modal_ref_copy
              modal_primary_button_text
              modal_secondary_button_text
              section_id
            }
        },
        ... on PRISMIC_TrustcenterBodyTablemodal {
          type
            label
            primary {
              background_color
              background_image
              heading
              heading_color
              subheading
              subheading_color
              text_color
              modal_title
              modal_copy
              primary_button_text
              secondary_button_text
            }
            fields {
              column_heading
              column_row_1
              column_row_1_download_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              column_row_2
              column_row_2_download_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              column_row_3
              column_row_3_download_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              column_row_4
              column_row_4_download_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              column_row_5
              column_row_5_download_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              column_row_6
              column_row_6_download_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              column_row_7
              column_row_7_download_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              column_row_8
              column_row_8_download_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              column_row_9
              column_row_9_download_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              column_row_10
              column_row_10_download_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              column_row_11
              column_row_11_download_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              column_row_12
              column_row_12_download_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                 ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
              column_row_13
              column_row_13_download_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
                ... on PRISMIC__FileLink {
                  _linkType
                  url
                }
              }
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Trustcenter = ({ data, location }) =>
  data.prismic.trustcenter ? (
    <MainLayout location={location} layout='trustcenter'>
    <Helmet>
      <title>{(data.prismic.trustcenter.title[0] && data.prismic.trustcenter.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.trustcenter.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.trustcenter.path : 'https://www.digitalocean.com' + data.prismic.trustcenter.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.trustcenter.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.trustcenter.title[0] ? data.prismic.trustcenter.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.trustcenter.description ? data.prismic.trustcenter.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.trustcenter.open_graph_image ? data.prismic.trustcenter.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.trustcenter.description ? data.prismic.trustcenter.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.trustcenter.title[0] ? data.prismic.trustcenter.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.trustcenter.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.trustcenter.path : 'https://www.digitalocean.com' + data.prismic.trustcenter.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.trustcenter.open_graph_image ? data.prismic.trustcenter.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.trustcenter.body} />
    </MainLayout>
  ) : null;

Trustcenter.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Trustcenter;
